module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-backplates-remnants.f5d3a72b.png";